<template>
  <table class="table">
    <thead>
      <tr>
        <th>Qty</th>
        <th>Part</th>
        <th>SKU</th>
        <th>Item</th>
        <th>Cutsize</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(i, index) in bom" :key="index">
        <td>{{ i.qty }}</td>
        <td>{{ i.part }}</td>
        <td>
          <router-link :to="`/material/${i.material_id}`" target="_blank">{{
            i.sku
          }}</router-link>
        </td>
        <td>{{ i.name }}</td>
        <td>{{ i.cutsize }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    bom: Array,
  },
};
</script>